/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import { genarateNumber, toEnglishNumber } from 'common/method/helper';
import { RefreshCaptchaIcon } from 'common/Icons';
import { UseFormRegister, UseFormSetValue, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

interface CaptchaType {
  register: UseFormRegister<any>;
  errors: any;
  captcha: resCaptchaType | undefined;
  onRefresh: () => void;
  className?: string;
  setValue: UseFormSetValue<any>,
  getValues: UseFormGetValues<any>,
}

export const Captcha = ({
  register,
  errors,
  captcha,
  onRefresh,
  className = '',
  setValue,
  getValues
}: CaptchaType) => {
  const randomNum = genarateNumber();
  const [state, setState] = useState("")
  const { t } = useTranslation();

  // const placeHolder = t(`FormSide.Input.Captcha.Placeholder`);
  const placeHolder = "کد امنیتی را وارد کنید";

  const { name, ref } = register('captchaValue', {
    required: {
      value: true,
      message: t('Errors.Input.Required', {
        n: t('FormSide.Input.Captcha.Label'),
      }),
    },
    minLength: {
      value: 5,
      message: t('Errors.Input.Digits', {
        n: 5,
      }),
    },
  })

  const getSessionCaptcha = sessionStorage.getItem("isInvalidCaptcha")
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    // if (value.length >= 5 && state.length === 4) {
    //   console.log("to be have to blur")
    //   e.target.blur()
    // }
    if (value.length > 5) return
    setState(toEnglishNumber(value));
  }

  useEffect(() => {
    const handleFocus = () => {
      // Refetch data when the window gains focus or becomes visible
      if (document.visibilityState === 'visible') {
        onRefresh();

        // isInitialMount.current = false;
      }
    };

    // Set up event listeners for visibilitychange and focus
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('visibilitychange', handleFocus, false);
    }

    return () => {
      // Clean up event listeners
      if (typeof window !== 'undefined' && window.removeEventListener) {
        window.removeEventListener('visibilitychange', handleFocus);
      }
    };
  }, []);


  useEffect(() => {
    const valueForm = getValues(name)
    if (valueForm !== state) {
      setValue(name, state, { shouldValidate: true })
    }
  }, [state])

  useEffect(() => {
    const valueForm = getValues(name)
    if (valueForm !== state) {
      setState(valueForm)
    }
  }, [getValues(name)])


  return (
    <div className={className}>
      <label
        htmlFor={'captcha' + randomNum}
        className="block text-xl mb-2 md:text-b2xl xl:text-2xl md:font-medium xl:font-medium text-L-gray-250"
      >
        {t(`FormSide.Input.Captcha.Label`)}
      </label>

      <div className="relative">
        <input
          data-cy="captcha"
          id={'captcha' + randomNum}
          type="text"
          inputMode="numeric"
          placeholder={placeHolder}
          className={clsx(
            'ltrInsert rounded-2xl text-center tracking-[10px] border border-L-gray-100 outline-none w-full h-[48px] px-4 placeholder:text-xl placeholder:text-L-gray-150 bg-L-basic pl-[215px]',
            {
              '!border-L-error-150 outline-none': !!errors.captchaValue,
            }
          )}
          ref={ref}
          name={name}
          value={state}
          onChange={handleOnChange}
        />

        <div className="absolute top-[1px] left-[10px] flex items-center bg-transparent w-[178px] h-full select-none">
          {
            !captcha?.base64String || getSessionCaptcha ? (
              <p className='bg-gray-100 w-full h-[37px] mb-[1px] flex justify-center items-center rounded text-2xl'>
                لطفا مجددا تلاش کنید.
              </p>
            ) : (
              <img
                src={captcha?.base64String}
                // src={"/assets/images/defaultCaptcha.png"}
                width="187px"
                height="100%"
                alt=""
                className="object-fill h-[37px] mb-1"
              />
            )
          }

        </div>

        <div className="absolute inset-y-0 left-[184px] flex items-center pl-1 cursor-pointer">
          <RefreshCaptchaIcon
            className="text-L-secondary-50"
            onClick={(e) => {
              document.getElementById('captcha' + randomNum)?.focus()
              onRefresh()
            }}
          />
        </div>
      </div>

      {!!errors.captchaValue && (
        <p className="text-L-error-150 text-xl pt-1 float-right mb-2">
          {errors.captchaValue.message}
        </p>
      )}
    </div>
  );
};

export default Captcha;